module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_8011.36a59fb4.png";